import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/redux/store';
import { selectors as patientChartSelectors } from 'src/routes/IndividualDashboard/modules/dashboard/slice';
import { CUSTOMER_FEATURE_SETTINGS } from 'src/routes/Customers/modules/types';

type OwnProps = {
  featureName: CUSTOMER_FEATURE_SETTINGS;
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
  featureAvailable:
    patientChartSelectors.selectCurrentCustomerFeatureSettingByName(state)(
      ownProps.featureName,
    ),
});

const Connector = connect(mapStateToProps);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
